<template>
  <Favorites ref="favRef" />
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import { walletState } from "@/stores/wallet";

export default {
  name: "CallsList",
  components: {},
  data() {
    return {
      categories: [],
      subCategories: [],
      isLoading: true,
      token: localStorage.getItem("access_token"),
      courseCount: 0,
      isLoggedIn: false,
      catImagePath: baseUrl + "/images/category/",
      defaultImage: "/assets/img/acad-icon.png",
      student: {},
      loadingCategories: true, // Loading state for categories
      loadingCourses: true, // Loading state for courses
      currentStep: 1, // بداية في الخطوة 1
      selectedOption: "", // البيانات للـ select box
      textInput: "", // البيانات للـ input text
      numberInput: "", // البيانات للـ input number
      isChecked: false, // البيانات للـ checkbox
    };
  },
  mounted() {
    this.isLoggedIn =
      walletState.isLoggedIn || !!localStorage.getItem("access_token");
    this.isLoading = false;
  },
  methods: {
    formatDate(date) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    handleImageError(event) {
      // استبدال الصورة بصورة افتراضية إذا حدث خطأ مثل 404
      event.target.src = this.defaultImage;
    },
  },
};
</script>

<style scoped></style>
